var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-center"
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "600"
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('v-card', {
    staticClass: "not-margin pt-0 pr-0 pl-0"
  }, [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('v-icon', [_vm._v("mdi-eye")]), _vm._v(" Visualizar Setor ")], 1)]), _c('div', {
    staticClass: "container dialog"
  }, [_c('v-row', {
    staticClass: "justify-center mt-7"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.content.nome,
      "label": "Setor",
      "readonly": "",
      "outlined": "",
      "dense": ""
    }
  }), _c('v-text-field', {
    attrs: {
      "value": _vm.content.origem.nome.toUpperCase(),
      "label": "Origem",
      "readonly": "",
      "outlined": "",
      "dense": ""
    }
  }), _c('v-select', {
    attrs: {
      "label": "Cargos/Funções*",
      "outlined": "",
      "multiple": "",
      "return-object": "",
      "item-text": "nome",
      "item-value": "id",
      "chips": "",
      "readonly": "",
      "items": _vm.funcoes
    },
    model: {
      value: _vm.content.funcoes,
      callback: function ($$v) {
        _vm.$set(_vm.content, "funcoes", $$v);
      },
      expression: "content.funcoes"
    }
  })], 1)], 1)], 1), _c('div', {
    staticClass: "btn-group text-center"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('onClose');
      }
    }
  }, [_vm._v(" Fechar ")])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }